module.exports = __webpack_public_path__ + "img/couples-037.409cf6d6.jpg";